module.exports = __webpack_public_path__ + "media/images/calendar_today-black-18dp-fa7b4ac48ce71375cd02c45d2cb9759c.svg";